import React, { useCallback, useState } from "react";
import { Slider, Typography } from "@mui/material";
import SentimentSatisfiedAltIcon from "@mui/icons-material/SentimentSatisfiedAlt";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";
import Battery6BarIcon from "@mui/icons-material/Battery6Bar";
import Battery1BarIcon from "@mui/icons-material/Battery1Bar";

const moodTextMap = {
  1: "Awful",
  2: "Very bad",
  3: "Bad",
  4: "Pretty bad",
  5: "Okay",
  6: "Pretty good",
  7: "Good",
  8: "Very good",
  9: "Great",
  10: "Amazing",
};

const energyTextMap = {
  1: "Exhausted",
  2: "Very Tired",
  3: "Tired",
  4: "A little tired",
  5: "Okay",
  6: "Pretty active",
  7: "Active",
  8: "Very active",
  9: "Invigorated",
  10: "Supercharged",
};

const MindsetSelection = ({ onUpdateMindset, initialMindset }) => {
  const [mood, setMood] = useState(initialMindset.mood);
  const [energy, setEnergy] = useState(initialMindset.energy);

  const onMoodChange = useCallback(
    (event, value) => {
      if (value === mood) return;

      setMood(value);
      onUpdateMindset({
        mood: value,
        energy,
      });
    },
    [mood, energy],
  );

  const onEnergyChange = useCallback(
    (event, value) => {
      if (value === energy) return;

      setEnergy(value);
      onUpdateMindset({
        mood,
        energy: value,
      });
    },
    [mood, energy],
  );

  return (
    <div className="mindset-selection">
      <Typography variant="h2">How are you feeling today?</Typography>
      <div className="mindset-selection_inputs-container">
        <div className="mindset-selection_mood-container">
          <div className="mindset-selection_mood-input-container">
            <SentimentVeryDissatisfiedIcon className="mindset-selection_slider-icon" />
            <Slider
              aria-label="mood-slider"
              defaultValue={initialMindset.mood}
              step={1}
              marks
              min={1}
              max={10}
              onChangeCommitted={onMoodChange}
            />
            <SentimentSatisfiedAltIcon className="mindset-selection_slider-icon" />
          </div>
          <Typography variant="h3" className="mindset-selection_input-text">
            {moodTextMap[mood]}
          </Typography>
        </div>
        <div className="mindset-selection_energy-container">
          <div className="mindset-selection_energy-input-container">
            <Battery1BarIcon className="mindset-selection_slider-icon" />
            <Slider
              aria-label="energy-slider"
              defaultValue={initialMindset.energy}
              step={1}
              marks
              min={1}
              max={10}
              onChangeCommitted={onEnergyChange}
            />
            <Battery6BarIcon className="mindset-selection_slider-icon" />
          </div>
          <Typography variant="h3" className="mindset-selection_input-text">
            {energyTextMap[energy]}
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default MindsetSelection;
